<template>
    <div class="football-data">
      <div class="data-list">
        <template v-for="(item, index) in gameEvent">
          <div
            v-if="item.type === 'penaltyShootoutRound'"
            :key="'ps-' + item.id"
            class="data-item flex-center data-item--shootout"
          >
          <div class="card">
              <div v-if="item.home" class="player">
                <img :src="penaltyIcon(item.home.goalCount)" alt="">
                <span>[{{ item.home.userNumber }}]{{ item.home.userName }}</span>
              </div>
            </div>
            <div class="time time--spot">点</div>
            <div class="card">
              <div v-if="item.away" class="player">
                <img :src="penaltyIcon(item.away.goalCount)" alt="">
                <span>[{{ item.away.userNumber }}]{{ item.away.userName }}</span>
              </div>
            </div>
            <div class="line" :class="{'last-line': index === gameEvent.length - 1, 'one-line': index === 0}" />
          </div>
          <div
            v-else
            :key="'ev-' + item.id"
            class="data-item flex-center"
          >
          <div class="card" v-if="item.teamId === homeTeamId">
             <div class="player">
                <img src="@/assets/match-team-game/goal-symbol.svg" v-if="item.type === 'goal'" />
                <img src="@/assets/match-team-game/own-goal-symbol.svg" v-else-if="item.type === 'ownGoal'" />
                <img src="@/assets/match-team-game/penalty-goal-symbol.svg" v-else-if="item.type === 'penalty'" />
                <img src="@/assets/match-team-game/yellow-card-symbol.svg" v-else-if="item.type === 'yellow'" />
                <img src="@/assets/match-team-game/yellow-red-card-symbol.svg" v-else-if="item.type === 'yellowRed'" />
                <img src="@/assets/match-team-game/red-card-symbol.svg" v-else-if="item.type === 'red' || item.type === 'leaveBench'" />
                <img src="@/assets/match-team-game/substitution-down-symbol.svg" v-else-if="item.type === 'changes'" />
                <span>[{{ item.userNumber }}]{{ item.userName }}</span>
             </div>
              <div class="player" v-if="item.otherName">
                <img src="@/assets/match-team-game/assist-symbol.svg" v-if="item.type === 'goal' || item.type === 'penalty'" />
                <img src="@/assets/match-team-game/substitution-up-symbol.svg" v-else-if="item.type === 'changes'" />
                <span>[{{ item.otherNumber }}]{{ item.otherName }}</span>
             </div>
          </div>
          <div v-else class="card" style="background-color: #fff;"></div>
          <div class="time">{{ item.time }}'</div>
          <div class="card" v-if="item.teamId === awayTeamId">
             <div class="player">
                <img src="@/assets/match-team-game/goal-symbol.svg" v-if="item.type === 'goal'" />
                <img src="@/assets/match-team-game/own-goal-symbol.svg" v-else-if="item.type === 'ownGoal'" />
                <img src="@/assets/match-team-game/penalty-goal-symbol.svg" v-else-if="item.type === 'penalty'" />
                <img src="@/assets/match-team-game/yellow-card-symbol.svg" v-else-if="item.type === 'yellow'" />
                <img src="@/assets/match-team-game/yellow-red-card-symbol.svg" v-else-if="item.type === 'yellowRed'" />
                <img src="@/assets/match-team-game/red-card-symbol.svg" v-else-if="item.type === 'red' || item.type === 'leaveBench'" />
                <img src="@/assets/match-team-game/substitution-down-symbol.svg" v-else-if="item.type === 'changes'" />
                <span>[{{ item.userNumber }}]{{ item.userName }}</span>
             </div>
              <div class="player" v-if="item.otherName">
                <img src="@/assets/match-team-game/assist-symbol.svg" v-if="item.type === 'goal' || item.type === 'penalty'" />
                <img src="@/assets/match-team-game/substitution-up-symbol.svg" v-else-if="item.type === 'changes'" />
                <span>[{{ item.otherNumber }}]{{ item.otherName }}</span>
             </div>
          </div>
          <div v-else class="card" style="background-color: #fff;"></div>
          <div class="line" :class="{'last-line': index === gameEvent.length - 1, 'one-line': index === 0}"></div>
          </div>
        </template>
      </div>
      <van-row type="flex" justify="center" class="u-outer-padding football-data__legend">
        <van-col span="4" class="vertical-center justify-center">
          <img src="@/assets/match-team-game/goal-symbol.svg" alt="" />
          <span class="l-inner-margin minor-text">{{ locale['goal'] }}</span>
        </van-col>
        <van-col span="4" class="vertical-center justify-center">
          <img src="@/assets/match-team-game/penalty-goal-symbol.svg" alt="" />
          <span class="l-inner-margin minor-text">{{ locale['penalty-goal'] }}</span>
        </van-col>
        <van-col span="4" class="vertical-center justify-center">
          <img src="@/assets/match-team-game/own-goal-symbol.svg" alt="" />
          <span class="l-inner-margin minor-text">{{ locale['own-goal'] }}</span>
        </van-col>
        <van-col span="4" class="vertical-center justify-center">
          <img src="@/assets/match-team-game/assist-symbol.svg" alt="" />
          <span class="l-inner-margin minor-text">{{ locale['assist'] }}</span>
        </van-col>
        <van-col span="4" class="vertical-center justify-center">
          <img src="@/assets/match-team-game/yellow-card-symbol.svg" alt="" />
          <span class="l-inner-margin minor-text">{{ locale['yellow-card'] }}</span>
        </van-col>
        <van-col span="4" class="vertical-center justify-center">
          <img src="@/assets/match-team-game/red-card-symbol.svg" alt="" />
          <span class="l-inner-margin minor-text">{{ locale['red-card'] }}</span>
        </van-col>
      </van-row>
    </div>
</template>

<script>
import Game from '@/tbs/model/to/Game'
import penalty0 from '@/assets/match-team-game/penalty0.png'
import penalty1 from '@/assets/match-team-game/penalty1.png'

export default {
  props: {
    gameEvent: {
      type: Array,
      default: () => []
    },
    homeTeamId: {
      type: [String, Number],
      default: ''
    },
    awayTeamId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      locale: new Game(),
    };
  },
  methods: {
    penaltyIcon(goalCount) {
      return Number(goalCount) === 1 ? penalty1 : penalty0
    },
  },
};
</script>

<style scoped lang="scss">
.football-data {
  .football-data__legend {
    margin-top: 4px;
    padding-bottom: 8px;
    font-size: 10px;
    color: #4D4D4D;
    img {
      height: 13px;
      width: 13px;
      flex-shrink: 0;
      display: block;
      margin-right: 4px;
    }

    &::v-deep .van-col.vertical-center.justify-center {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .data-list {
    padding: 0 10px;
    font-size: 0;
    .data-item {
      padding-bottom: 17px;
      position: relative;
      .card{
        width: 125px;
        border-radius: 5px;
        background: #F7F7F7;
        padding: 8px 0;
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        .player + .player {
          margin-top: 8px;
        }
        .player {
          color: #4D4D4D;
          font-size: 12px;
          height: 16px;
          display: flex;
          align-items: center;
          img{
            width: 13px;
            height: 13px;
            margin-right: 9px;
          }
        }
      }
      .time {
        width: 25px;
        height: 25px;
        border-radius: 12px;
        background: #FFFFFF;
        box-sizing: border-box;
        border: 0.4px solid #E8E8E8;
        font-size: 12px;
        font-weight: bold;
        color: #525252;
        text-align: center;
        line-height: 25px;
        &.time--spot {
          font-size: 10px;
          font-weight: 600;
          color: #525252;
        }
      }
      .line {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 1px;
        height: 100%;
        background: #D8D8D8;
        z-index: -1;
        top: 0;
      }
      .one-line{
        top: 50%;
        height: 50%;
      }
      .last-line{
        top: 0;
        height: 50%;
      }
    }
  }
}
</style>
